import { render, staticRenderFns } from "./bottomButtonGroup.vue?vue&type=template&id=523c5dd2&scoped=true&"
import script from "./bottomButtonGroup.vue?vue&type=script&lang=js&"
export * from "./bottomButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./bottomButtonGroup.vue?vue&type=style&index=0&id=523c5dd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c5dd2",
  null
  
)

export default component.exports